import {
    colorBaseGreyWarm600,
    headerTinyFontWeight,
    Link,
    LinkColor,
    paragraphTinyFontSize,
} from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import DocumentContext from '../DocumentPage/DocumentContext';

const CategoryTags = styled.div`
    margin: 1em 0;

    > a {
        display: inline-block;
        background-color: ${colorBaseGreyWarm600};
        border-radius: 1em;
        text-transform: uppercase;
        padding: 0.2em 0.7em;
        margin-right: 1em;
        cursor: pointer;
        font-size: ${paragraphTinyFontSize};
        font-weight: ${headerTinyFontWeight};
    }
`;
export const Categories: React.FC = () => {
    const { categories } = useContext(DocumentContext);
    if (categories.length === 0) return null;
    return (
        <CategoryTags>
            {categories.map(category => (
                <Link color={LinkColor.White} href={category.path} key={`category_${category.id}`}>
                    {category.label}
                </Link>
            ))}
        </CategoryTags>
    );
};
